<template>
  <div class="page">
    <LoginButton />
    <div class="flex-col flex-justify-center flex-align-center">
      <div class="flex-row justify-between">
        <div class="flex-col justify-between">
          <span class="text_1">Welcome</span>
          <div class="text-wrapper_1 flex-row">
            <span class="text_2">欢迎使用AI多面体，即刻上传您的简历，离工作更近一步吧！</span>
          </div>
        </div>
      </div>
      <div class="wrapper flex-row">
        <img class="bg-pic" referrerpolicy="no-referrer" src="./assets/img/shuziren.png" />
        <div class="flex-row justify-center" style="gap:20px; flex-wrap: nowrap; align-items: flex-start;">
          <div class="flex-col justify-between group_5">
            <div class="section_2 flex-col">
              <el-upload :class="{ 'UploadedColor': CvUploaded }" style="width:100%;height:100%;" drag accept=".pdf" :auto-upload="false" :on-change="UploadCvFunc" :on-remove="RemoveCvFunc" action="#" :limit="1" ref="CvUpload" :disabled="false" :show-file-list="false">
                <div v-if="CvUploaded" style="position: relative; width: 100%; height: 100%;">
                  <div class="image-wrapper_2_ flex-row" @click="RemoveCvFunc()" @click.stop style="position: absolute; right: 10px; top: 10px; z-index: 2; cursor: pointer;">
                    <img class="label_1_" referrerpolicy="no-referrer" src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" style="width: 26px; height: 27px; object-fit: contain;" />
                  </div>
                  <div class="box_1_ flex-row" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 100%; padding: 10px;">
                    <div class="image-text_1_ flex-col justify-between" style="display: flex; flex-direction: column; align-items: center; gap: 10px; width: 100%;">
                      <img class="image_2_" referrerpolicy="no-referrer" src="./assets/img/resume.png" style="max-width: 80px; max-height: 60px; object-fit: contain; " />
                      <span class="text-group_1_" style="max-width: 100%; white-space: normal; text-align: center; font-size: 14px; color: rgba(101, 101, 135, 1);">
                        {{ uploadedCvFileName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="image-text_1 flex-col justify-between">
                    <div class="lib" @click.stop="openResumeLibraryModal">
                      <span>简历库上传我的简历</span>
                    </div>
                    <!-- 微信扫码上传按钮 -->
                    <div class="wechat-upload-section-inline">
                      <div class="wechat-upload-button-inline" @click.stop="openWechatUploadModal">
                        <svg class="wechat-icon-inline" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 4.882-1.932 7.621-.568-.302-3.706-3.78-6.6-8.1-6.6zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18z" />
                          <path d="M17.301 13.03c1.952 0 3.535-1.62 3.535-3.62s-1.583-3.62-3.535-3.62c-1.952 0-3.535 1.62-3.535 3.62s1.583 3.62 3.535 3.62zm-1.767-3.62c0-.651.52-1.18 1.162-1.18s1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178zm-3.535 0c0-.651.52-1.18 1.162-1.18s1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178z" />
                        </svg>
                        <span class="wechat-text-inline">微信扫码上传简历</span>
                      </div>
                    </div>
                    <span style="margin-top:5px;font-size: 12px;color: black;">OR</span>
                    <img class="image_2" referrerpolicy="no-referrer" src="./assets/img/FigmaDDSSlicePNGb08c124320a32285f623dfb4adb6d243.png" />
                    <span class="text-group_1">
                      拖拽或点击上传简历
                      <br />
                      仅支持PDF格式
                    </span>
                  </div>
                  <div class="box_3 flex-row justify-between">
                    <span class="text_6">上传简历</span>
                    <div class="group_6 flex-col"></div>
                  </div>
                </div>
              </el-upload>
            </div>

            <div class="group_7">
              <div class="flex-row">
                <span class="text_7" style="font-weight:bold;">选择本场面试时长</span>
                <div class="custom-dropdown-container">
                  <div @click="toggleDropdown" class="custom-dropdown-button">
                    <span class="color-text" style="font-size:14px; font-weight:bold;">{{ duration || '请选择' }}</span>
                    <img src="./assets/img/arrow.png" class="custom-arrow-icon" :class="{ 'arrow_rotate_up': dropdownVisible }">
                  </div>
                  <div v-show="dropdownVisible" class="custom-dropdown">
                    <div @click="selectOption('')" class="custom-dropdown-item">请选择</div>
                    <div @click="selectOption(15)" class="custom-dropdown-item">15min</div>
                  </div>
                </div>
              </div>
              <div class="language-selection flex-row">
                <span class="text_7" style="font-weight:bold; margin-left: 24px;">选择面试语言</span>
                <div class="custom-dropdown-container">
                  <div @click="toggleLanguageDropdown" class="custom-dropdown-button">
                    <span class="color-text" style="font-size:14px; font-weight:bold;">{{ language || '请选择' }}</span>
                    <img src="./assets/img/arrow.png" class="custom-arrow-icon" :class="{ 'arrow_rotate_up': languageDropdownVisible }">
                  </div>
                  <div v-show="languageDropdownVisible" class="custom-dropdown">
                    <div @click="selectLanguage('')" class="custom-dropdown-item">请选择</div>
                    <div @click="selectLanguage(1)" class="custom-dropdown-item">中文</div>
                    <div @click="selectLanguage(2)" class="custom-dropdown-item">英文</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="group_9 flex-col justify-between">
            <div class="group_10 flex-col">
              <div class="flex-col box_4">
                <el-upload :class="{ 'UploadedColor': JdUploaded }" style="width:100%;height:100%;" drag accept=".pdf,.doc,.docx,.txt,image/*" :auto-upload="false" :on-change="UploadJdFunc" :on-remove="RemoveJdFunc" action="#" :limit="1" ref="JdUpload" :disabled="false" :show-file-list="false">
                  <!-- JD上传后预览区域 -->
                  <div v-if="JdUploaded" style="position: relative; width: 100%; height: 100%;">
                    <!-- JD关闭按钮 -->
                    <div class="image-wrapper_3_ flex-row" @click="RemoveJdFunc()" @click.stop style="position: absolute; right: 10px; top: 10px; z-index: 2; cursor: pointer;">
                      <img class="label_2_" referrerpolicy="no-referrer" src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" style="width: 26px; height: 27px; object-fit: contain;" />
                    </div>
                    <!-- JD预览容器 -->
                    <div class="group_6_ flex-row" style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 100%; padding: 10px;">
                      <div class="image-text_2_ flex-col justify-between" style="display: flex; flex-direction: column; align-items: center; gap: 10px; width: 100%;">
                        <!-- JD图片 -->
                        <img class="image_3_" referrerpolicy="no-referrer" src="./assets/img/jd.png" style="max-width: 80px; max-height: 60px; object-fit: contain;" />
                        <!-- JD文件名 -->
                        <span class="text-group_2_" style="max-width: 100%; white-space: normal; text-align: center; font-size: 14px; color: rgba(101, 101, 135, 1);">
                          {{ uploadedJdFileName }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="image-text_2 flex-col justify-between">
                      <div class="lib" @click.stop="showModal = true;showSearch=false;">
                        <span>AI自动生成岗位要求</span>
                      </div>
                      <!-- 微信扫码上传按钮 -->
                      <div class="wechat-upload-section-inline">
                        <div class="wechat-upload-button-inline" @click.stop="openWechatUploadModal">
                          <svg class="wechat-icon-inline" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 4.882-1.932 7.621-.568-.302-3.706-3.78-6.6-8.1-6.6zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18z" />
                            <path d="M17.301 13.03c1.952 0 3.535-1.62 3.535-3.62s-1.583-3.62-3.535-3.62c-1.952 0-3.535 1.62-3.535 3.62s1.583 3.62 3.535 3.62zm-1.767-3.62c0-.651.52-1.18 1.162-1.18s1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178zm-3.535 0c0-.651.52-1.18 1.162-1.18s1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178z" />
                          </svg>
                          <span class="wechat-text-inline">微信扫码上传岗位JD</span>
                        </div>
                      </div>
                      <span style="margin-top:5px;font-size: 12px;color: black;">OR</span>
                      <img class="image_3" referrerpolicy="no-referrer" src="./assets/img/FigmaDDSSlicePNGb08c124320a32285f623dfb4adb6d243.png" />
                      <span class="text-group_2">
                        拖拽或点击上传岗位要求
                        <br />
                        支持PDF、Word、TXT、所有图片格式
                      </span>
                    </div>
                    <div class="box_5">
                      <div class="row-container flex-row justify-between">
                        <span class="text_9">上传岗位JD</span>
                        <div class="section_3 flex-col"></div>
                      </div>
                    </div>
                  </div>
                </el-upload>
              </div>
            </div>
            <button class="text-wrapper_5 flex-row" :class="{ 'ready-go': readyGo }" :disabled="!readyGo" @click="handleClickReadyGo()">
              <span class="text_10" :style="{ 'color': readyGo ? 'white' : 'rgba(0, 0, 0, 0.25)' }">准备好了 GO!</span>
            </button>

          </div>
        </div>
      </div>

    </div>
    <!-- 弹窗容器 -->
    <div class="modal-container" v-if="showModal" @click.self="handleClose">
      <!-- 遮罩层 -->
      <div class="modal-mask"></div>

      <!-- 弹窗内容 -->
      <div class="modal-content" @click.stop>
        <div class="header">
          <div class="title" v-if="showRequirements == 0">请选择岗位以生成岗位需求</div>
          <div class="title" v-if="showRequirements == 1">岗位要求</div>
          <div class="close-btn" @click="handleClose">
            <i class="el-icon-close" style="font-size: 16px;border: 1px solid #fff;border-radius: 50%;color: #fff;padding:2px;"></i>
          </div>
        </div>
        <div class="search_box" v-if="showSearchInput">
          <input v-model="searchQuery" type="text" class="search-input" placeholder="搜索岗位名称" @focus="searchVal" @keyup.enter="searchChange" />
          <img src="@/assets/image/search.png" alt="" style="width: 40px;" class="search-icon" @click="searchChange">
        </div>
        <div class="content">
          <div v-if="showSearch" style="display: flex;justify-content: space-between;width: 100%;  background: #fff;">
            <div class="row_list">
              <div class="row_item" v-for="(item,index) in JobInformation" :key="index" @click="handleSelectJob(item)" :class="{ 'row_selected': selectedJobs[0]?.includes(item.name) }">
                <div class="item_title">{{item.name}}</div>
                <div class="item_content">{{ item.categories }}</div>
              </div>
            </div>
            <div class="action_row">
              <div v-if="generatedLoading" class="loading_row">
                <div class="btn btn-primary" style="width: 250px;text-align: center;" @click="generatedLoading=false">重选岗位</div>
                <div :class="['btn','btn-primary',{'btn-disabled':generatedLoading}]" style="width: 250px;text-align: center;">重新生成</div>
                <div :class="['btn','btn-primary',{'btn-disabled':generatedLoading}]" style="width: 250px;text-align: center;">确定并使用</div>
              </div>
              <div v-else class="action_row">
                <div style="display: flex; align-items: center; gap: 30px; ">
                  <div class="btn return_search" @click="returnSearch">退出搜索</div>
                  <div style="font-size: 16px;color: #656587;">当前选择：<span style="color: #9D89F9;font-weight: bold;background:linear-gradient(90deg, rgba(119,186,255,1) 0%, rgba(156,65,255,1) 100%);
color:transparent;
-webkit-background-clip:text;">{{ selectedJobs[0] }}</span></div>
                </div>
                <div style="font-size: 16px;color: #FFF;" class="btn btn-primarys" @click="generateRequirements()">生成岗位需求</div>
              </div>

            </div>
          </div>
          <span v-else style="display: flex; height: 100%;width: 100%;">
            <div class="sidebar" v-if="showRequirements == 0">
              <div v-for="(item, index) in categories" :key="index" class="sidebar-item" :class="{ active: currentCategory === item }" @click="handleCategoryClick(item)">
                <div :style="{ visibility: currentCategory === item ? 'visible' : 'hidden',display:'inline-block' }" class="dot">·</div> {{ item }}
              </div>
            </div>
            <div class="main-content" :style="mainStyle" >
              <div class="category" v-if="showRequirements == 0">
                <div style="display: flex;flex-direction: column;gap: 30px;">
                  <div v-for="(job, doman) in filteredJobs" :key="doman">
                    <div style="font-weight: 700;font-size: 16px;color: #656587;margin-bottom: 20px;">{{ doman }}</div>
                    <div class="job-list">
                      <div v-for="(jobTitles,label) in job" :key="label">
                        <div class="job-item" :class="{ 'selected': selectedJobs.includes(jobTitles) }" @click="handleJobClick(jobTitles)">{{ jobTitles }}</div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <!-- 手动输入岗位弹窗 -->
              <div v-if="showManualInput" class="manual-input-modal-overlay" @click="handleManualCancel">
                <div class="manual-input-modal" @click.stop>
                  <!-- 弹窗头部 -->
                  <div class="manual-input-header">
                    <div class="manual-input-title">请手动输入岗位名称以生成岗位需求</div>
                    <div class="manual-input-close" @click="handleManualCancel">
                      <i class="el-icon-close"></i>
                    </div>
                  </div>
                  
                  <!-- 弹窗内容 -->
                  <div class="manual-input-content">
                    <input 
                      v-model="manualJob" 
                      placeholder="请输入您想应聘的岗位名称" 
                      class="manual-input-field" 
                      @keyup.enter="handleManualConfirm"
                      ref="manualInputRef"
                    />
                    
                    <!-- 底部按钮 -->
                    <div class="manual-input-footer">
                      <button class="btn btn-back" @click="handleManualCancel">返回</button>
                      <button class="btn btn-clear" @click="manualJob = ''">清空</button>
                      <button 
                        class="btn btn-generate" 
                        @click="handleManualConfirm"
                        :disabled="!manualJob.trim()"
                      >生成岗位需求</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="generated-requirements" v-if="showRequirements == 1" :style="{maxHeight:loading?'calc(100% - 50px)':'calc(100% - 80px)'}">
                
                <div v-if="!loading" style="font-size:20px;">岗位名称：<span style="font-weight: 700;color: #8B85F8;">{{ selectedJobs[0] }}</span></div>
                <!-- ① 加载中 -->
                <div v-if="loading" class="loading">
                  <div style="display:flex;justify-content: center;gap: 20px;flex-direction: column;width: 100%;align-items: center;">
                    <img src="@/assets/image/loading.png" style="width: 500px;" />
                    <div class="tips_txt">正在为您生成<span style="font-weight: 700;color: #8B85F8;">{{selectedJobs[0]}}</span>的岗位要求<i class="el-icon-loading" /></div>
                    <div class="tips_txt">请稍等~</div>
                  </div>
                </div>

                <!-- ② 数据回来后再渲染列表 -->
                <template v-else>
                  <h3 style="margin-top: 40px;">工作内容：</h3>
                  <ul>
                    <li v-for="(item, index) in jobContent" :key="index" style="line-height: 1.8;">{{ item }}</li>
                  </ul>
                  <h3 style="margin-top: 40px;">岗位要求：</h3>
                  <ul>
                    <li v-for="(item, index) in jobRequirements" :key="index" style="line-height: 1.8;">{{ item }}</li>
                  </ul>

                </template>
              </div>
              <div class="buttons">
                <div class="buttons-left">
                  <div style="font-size: 16px;color: #656587;" v-if="!showRequirements">当前选择：<span style="color: #9D89F9;font-weight: bold;background:linear-gradient(90deg, rgba(119,186,255,1) 0%, rgba(156,65,255,1) 100%);
color:transparent;
-webkit-background-clip:text;">{{ selectedJobs[0] }}</span></div>
                </div>
                <div class="buttons-right">
                  <div class="button-group">
                    <button class="btn btn-manual" @click="handleManual" v-if="showRequirements == 0">手动输入岗位</button>
                    <button class="btn btn-primarys" @click="generateRequirements" v-if="showRequirements == 0 || showRequirements == 2" :class="[{'btn-disabled':!selectedJobs.length}]">生成岗位要求</button>
                  </div>
                  <div class="button-group button-group-center">
                    <button class="btn btn-return" @click="handleBack" v-if="showRequirements" style="width: 250px;text-align: center;">重选岗位</button>
                    <button :class="['btn','btn-restart',{'btn-disabled':loading}]" @click="generateRequirements" v-if="showRequirements == 1" style="width: 250px;text-align: center;">重新生成</button>
                    <button :class="['btn','btn-primarys',{'btn-disabled':loading}]" @click="handleConfirm" v-if="showRequirements == 1" style="width: 250px;text-align: center;">确定并使用</button>
                  </div>
                </div>
              </div>
            </div>

          </span>

        </div>
      </div>
    </div>

    <!-- 微信扫码上传弹窗 -->
    <div class="wechat-modal-container" v-if="showWechatModal" @click.self="closeWechatModal">
      <!-- 遮罩层 -->
      <div class="wechat-modal-mask"></div>

      <!-- 弹窗内容 -->
      <div class="wechat-modal-content" @click.stop>
        <div class="wechat-header">
          <div class="wechat-title">扫码上传岗位要求</div>
          <div class="wechat-close-btn" @click.stop="closeWechatModal">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="wechat-content">
          <div class="wechat-qr-container">
            <!-- 加载状态 -->
            <div v-if="qrCodeLoading" class="qr-loading">
              <div class="spinner"></div>
              <p>正在生成二维码...</p>
            </div>

            <!-- 二维码显示 -->
            <div v-else>
              <img class="wechat-qr-code" :src="wechatQRCodeUrl" alt="微信扫码二维码" />
              <p class="wechat-hint">使用微信扫一扫上传文件</p>

              <!-- 连接状态 -->
              <div class="connection-status">
                <span class="status-dot" :class="{ connected: wsConnected }"></span>
                <span class="status-text">{{ wsConnected ? '实时连接中' : '等待连接' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="avatar-expander" :class="{ expanded: isExpanded }" @click="toggleExpand">
      <!-- 使用图片代替图标，根据状态切换显示的图片 -->
      <img :src="isExpanded ? collapseImg : expandImg" alt="切换按钮" class="toggle-image">
      <div class="avatar-container">
        <div class="avatar" v-for="(avatar, index) in avatars" :key="index" @click.stop="handleAvatarClick(index)">
          <img :src="avatar.src" :alt="avatar.alt">
        </div>
      </div>
    </div>

    <!-- 简历库选择弹窗 -->
    <div class="resume-library-modal-container" v-if="showResumeLibraryModal" @click.self="closeResumeLibraryModal">
      <!-- 遮罩层 -->
      <div class="resume-library-modal-mask"></div>

      <!-- 弹窗内容 -->
      <div class="resume-library-modal-content" @click.stop>
        <!-- 头部 -->
        <div class="resume-library-header">
          <div class="resume-library-title">选择简历</div>
          <div class="resume-library-close-btn" @click.stop="closeResumeLibraryModal">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <!-- 内容区域 -->
        <div class="resume-library-body">
          <div v-if="resumeLibraryList.length === 0" class="empty-state">
            <div class="empty-icon">
              <i class="el-icon-document" style="font-size: 48px; color: #c0c4cc;"></i>
            </div>
            <div class="empty-text">简历库中暂无简历</div>
            <div class="empty-tip">请先上传简历到简历库</div>
            <button class="upload-resume-btn" @click="goToResumeManagement">
              <i class="el-icon-upload"></i>
              上传简历至简历库
            </button>
          </div>
          
          <div v-else class="resume-list">
            <div 
              v-for="(resume, index) in resumeLibraryList" 
              :key="index" 
              class="resume-item"
              @click="selectResume(resume)"
            >
              <div class="resume-info">
                <div class="resume-name">{{ resume.name }}</div>
                <div class="resume-meta">
                  <span class="upload-time">上传时间：{{ resume.uploadTime }}</span>
                  <span class="file-size">文件大小：{{ resume.size }}</span>
                </div>
              </div>
              <div class="resume-actions">
                <button class="select-btn">选择</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  test_uesrinfo,
  generateJDByPosition,
  checkInterview,
} from "@/api/user";
import {
  lxUploadFile,
  generate_qrcode,
  createWebSocketConnection,
  onWebSocketMessage,
  closeWebSocketConnection,
} from "@/api/upload";

import { getRecommendId, getGenerateJson } from '@/api/recommend'
import { getResumeList } from '@/api/resume'
import dropdownMethods from './methods'
import { mapState } from 'vuex'
import { setToken, removeToken, getToken } from '@/store/local/auth'

export default {
  computed: {
    ...mapState("interviewState", ["jd", "cv"]),
    buttonsStyle() {
      if (this.showRequirements == 0) {
        return { left: "100px", bottom: "50px" };
      } else if (this.showRequirements == 1 || this.showRequirements == 2) {
        return { left: "200px", bottom: "20px" };
      }
    },
    mainStyle() {
      if (this.showRequirements) {
        // return { "background-color": "#DFE1EB" };
      } else {
        return { "background-color": "#FFF",'padding':'20px 40px 40px 40px' };
      }
    },
    filteredJobs() {
      console.log(this.jobs[this.currentCategory]);
      // 根据 currentCategory 返回对应的岗位列表

      return this.jobs[this.currentCategory];
      console.log(this.jobs[this.currentCategory]);
    },
    readyGo() {
      return (
        this.duration != "" &&
        this.language != "" &&
        this.CvUploaded &&
        this.JdUploaded &&
        !this.waitingForPrompt
      );
    },
    uploadedJdFileName() {
      return this.jd ? this.jd.name || "job_description.txt" : "";
    },
    uploadedCvFileName() {
      return this.cv ? this.cv.name || "resume.pdf" : "";
    },
    JdUploaded() {
      return this.jd !== null && this.jd.url;
    },
    CvUploaded() {
      return this.cv !== null && this.cv.url;
    },
    getAvatarUrl() {
      // 确保返回原始的URL，不被任何处理逻辑修改
      const url = this.avatar;
      return url;
    },
  },
  data() {
    return {
      searchQuery: "", // 搜索关键词
      // 控制按钮展开/收缩状态
      isExpanded: false,
      // 展开和收缩状态的图片
      expandImg: require("./assets/img/circle.png"),
      collapseImg: require("./assets/img/rank.png"),
      // 头像数据
      avatars: [
        { src: require("./assets/img/1.png"), alt: "用户头像1" },
        { src: require("./assets/img/2.png"), alt: "用户头像2" },
        { src: require("./assets/img/3.png"), alt: "用户头像3" },
        { src: require("./assets/img/4.png"), alt: "用户头像4" },
      ],
      showManualInput: false,
      manualJob: "",
      loading: false,
      showModal: false,
      categories: [
        "互联网岗位", 
        "电子/电气/通信", 
        "人力/行政/法务", 
        "会计", 
        "生产制造", 
        "教育培训", 
        "设计", 
        "房地产/建筑", 
        "直播/影视/传媒", 
        "市场/公关/广告", 
        "供应链", 
        "汽车", 
        "医疗健康", 
        "金融", 
        "项目管理", 
        "咨询/翻译/法律", 
        "能源/环保/农业", 
        "高级管理"
      ],
      currentCategory: "互联网岗位",
      jobs: {
        "互联网岗位": {
          "后端开发": [
            "Java", "C/C++", "PHP", "Python", "C# .NET", "Golang", "Node.js"
          ],
          "语音/视频/图形开发": [
            "语音/视频/图形开发"
          ],
          "高性能计算工程师": [
            "高性能计算工程师"
          ],
          "GIS工程师": [
            "GIS工程师"
          ],
          "区块链工程师": [
            "区块链工程师"
          ],
          "全栈工程师": [
            "全栈工程师"
          ],
          "软件项目经理": [
            "软件项目经理"
          ],
          "前端/移动开发": [
            "前端开发工程师", "Android", "iOS", "U3D", "UE4", "Cocos", "技术美术", "JavaScript", "鸿蒙开发工程师"
          ],
          "测试": [
            "测试工程师", "软件测试", "自动化测试", "功能测试", "测试开发", "硬件测试", "游戏测试", "性能测试", "渗透测试", "测试经理"
          ],
          "运维/技术支持": [
            "运维工程师", "IT技术支持", "网络工程师", "网络安全", "系统工程师", "运维开发工程师", "系统管理员", "DBA", "电脑/打印机维修", "系统安全", "技术文档工程师"
          ],
          "人工智能/算法": [
            "图像算法", "自然语言处理算法", "大模型算法", "数据挖掘", "规控算法", "SLAM算法", "推荐算法", "搜索算法", "语音算法", "风控算法", "高性能计算工程师", "算法工程师", "算法研究员", "机器学习", "深度学习", "自动驾驶工程师", "数据标注/AI训练师"
          ],
          "销售": [
            "售前技术支持", "售后技术支持", "销售技术支持", "客户成功"
          ],
          "数据分析": [
            "数据分析师", "数据开发", "数据仓库", "ETL工程师", "数据挖掘", "数据架构师", "爬虫工程师", "数据采集", "数据治理"
          ],
          "项目管理": [
            "项目经理/主管", "软件项目经理", "实施工程师", "实施顾问", "需求分析工程师", "项目专员/助理"
          ],
          "产品经理": [
            "产品经理", "产品专员/助理", "高级产品管理岗", "用户研究", "电商产品经理", "AI产品经理", "数据产品经理", "移动产品经理", "金融产品经理", "跨境电商产品开发", "化妆品产品经理", "硬件产品经理", "其他产品职位", "需求分析工程师"
          ],
          "游戏策划/制作": [
            "游戏策划", "系统策划", "游戏数值策划", "游戏制作人", "战斗策划", "关卡策划", "文本策划"
          ],
          "运营": [
            "内容运营", "新媒体运营", "直播运营", "视频运营", "内容运营", "微信运营", "国内电商运营", "跨境电商运营", "品类运营", "淘宝运营", "天猫运营", "京东运营", "拼多多运营", "亚马逊运营", "跨境电商产品开发", "阿里国际站运营", "运营助理", "运营专员", "产品运营", "SEO/SEM运营", "活动运营", "数据运营", "社群运营", "游戏运营", "品类运营", "用户运营", "运营网站运营", "文案编辑", "内容审核", "线下拓展运营", "商场运营"
          ],
          "编辑": [
            "文案编辑", "主编/副主编", "网站编辑", "医学编辑"
          ],
          "客服": [
            "客服专员", "客服主管", "客服经理", "网络客服", "电话客服", "售后客服", "售前客服"
          ]
        },
        "电子/电气/通信": {
          "电子/硬件开发": [
            "电子工程师", "硬件工程师", "嵌入式软件工程师", "FPGA开发", "单片机", "驱动开发工程师", "PCB工程师", "电子维修技术员", "射频工程师", "电路设计", "系统集成", "光学工程师", "DSP开发", "电源工程师", "电池工程师", "电声工程师"
          ],
          "半导体/芯片": [
            "集成电路IC设计", "数字IC验证工程师", "模拟版图设计工程师", "芯片测试工程师", "DFT工程师", "FAE", "数字前端设计师", "数字后端工程师", "模拟IC设计工程师"
          ],
          "电气/自动化": [
            "电气工程师", "电气设计工程师", "自动化工程师", "机电工程师", "建筑机电工程师", "电力工程师"
          ],
          "技术项目管理": [
            "项目经理/主管", "实施工程师", "实施顾问", "硬件项目经理", "项目专员/助理"
          ],
          "通信": [
            "通信项目专员", "通信项目经理", "通信技术工程师", "通信研发工程师", "数据通信工程师", "光网络工程师", "有线传输工程师", "核心网工程师", "通信标准化工程师", "网络工程师", "宽带装维", "无线/天线工程师"
          ]
        },
        "人力/行政/法务": {
          "人力资源": [
            "人力资源专员/助理", "人力资源经理/主管", "人力资源总监", "招聘", "HRBP", "培训", "员工关系", "组织发展", "企业文化", "薪酬绩效", "猎头顾问"
          ],
          "行政": [
            "行政专员/助理", "行政经理/主管", "行政总监", "前台", "后勤", "经理助理", "文员", "企业党建", "档案管理", "商务司机", "项目专员/助理"
          ],
          "法律服务": [
            "法务专员/助理", "法务经理/主管", "法务总监", "法律顾问", "律师"
          ]
        },
        "会计": {
          "会计": [
            "会计", "总账会计", "成本会计", "结算会计", "外勤会计", "建筑/工程会计"
          ],
          "审计/税务": [
            "审计", "税务"
          ],
          "高级财务职位": [
            "财务经理/主管", "财务总监/VP", "CFO"
          ],
          "其他财务岗位": [
            "出纳", "风控", "财务顾问", "财务分析/财务BP"
          ]
        },
        "生产制造": {
          "质量管理": [
            "质量管理/测试工程师", "质检员", "实验室技术员", "体系工程师", "体系审核员", "产品认证工程师", "失效分析工程师", "可靠度工程师", "供应商质量工程师", "医疗器械生产/质量管理", "汽车质量工程师", "计量工程师"
          ],
          "机械设计/制造": [
            "机械工程师", "机械结构工程师", "家电/3C结构工程师", "工艺工程师", "设备维修保养工程师", "机械设备工程师", "机电工程师", "机械制图员", "模具工程师", "夹具工程师", "材料工程师", "工业工程师(IE)", "仿真工程师", "热设计工程师", "注塑工程师", "焊接工程师", "铸造/锻造工程师"
          ]
        },
        "教育培训": {
          "教师": [
            "教师", "英语教师", "助教", "数学教师", "语文教师", "高中教师", "初中教师", "小学教师", "家教", "物理教师", "化学教师", "理科教师", "日语教师", "生物教师", "文科教师", "地理教师", "其他外语教师"
          ],
          "教育行政": [
            "教务管理", "校长/副校长", "班主任/辅导员", "教学管理", "园长/副园长", "就业老师"
          ],
          "科学探索培训": [
            "乐高教师", "机器人教师", "少儿编程老师"
          ],
          "职业培训": [
            "培训师", "拓展培训", "IT培训讲师", "财会培训讲师"
          ],
          "教育产品研发": [
            "课程设计", "课程编辑", "培训策划", "培训研究"
          ],
          "教培销售": [
            "课程顾问", "留学顾问"
          ]
        },
        "设计": {
          "视觉/交互设计": [
            "平面设计", "美工", "设计师助理", "UI设计师", "视觉设计师", "广告设计", "UX/交互设计师", "用户研究", "包装设计", "修图师"
          ],
          "环境设计": [
            "室内设计", "软装设计师", "展览/展示设计", "陈列设计", "照明设计", "园林/景观设计", "舞美设计师", "CAD绘图员"
          ],
          "工业/产品设计": [
            "家具设计", "工业设计", "珠宝设计", "家具拆单员", "服装/纺织设计", "鞋类设计师"
          ],
          "美术/3D/动画": [
            "3D设计师", "插画师", "动画设计", "原画师", "漫画师"
          ],
          "游戏设计": [
            "游戏场景", "游戏角色", "游戏UI设计", "游戏特效", "游戏动作", "游戏主美术"
          ],
          "设计管理": [
            "设计总监/经理", "视觉设计总监/经理"
          ]
        },
        "房地产/建筑": {
          "工程管理": [
            "建筑施工项目经理", "工程造价", "工程监理", "工程咨询", "施工员", "资料员", "材料员", "测绘/测量", "施工安全员", "工程检测员", "工程招投标"
          ],
          "装饰装修": [
            "室内设计", "软装设计师", "装修项目经理", "装修监理", "装修造价"
          ],
          "建筑/规划设计": [
            "土木/土建/结构工程师", "园林/景观设计", "建筑设计师", "建筑工程师", "弱电工程师", "建筑机电工程师", "给排水工程师", "暖通工程师", "幕墙工程师", "BIM工程师", "消防工程师", "水利工程师", "城乡规划设计"
          ],
          "房地产规划开发": [
            "房地产项目管理", "房地产策划", "房地产估价师"
          ],
          "房地产销售/招商": [
            "置业顾问", "地产中介", "地产招商"
          ]
        },
        "直播/影视/传媒": {
          "直播": [
            "主播", "带货主播", "直播运营", "游戏主播", "中控/场控/助播"
          ],
          "影视": [
            "化妆/造型/服装", "演员/配音员", "艺人助理", "主持人/DJ", "模特", "摄影/摄像师", "导演/编导", "经纪人/星探", "编剧", "制片人", "影视策划", "影视发行", "视频剪辑", "后期制作", "动画设计", "修图师", "灯光师", "录音/音效", "音频编辑", "影视特效", "剧本杀主持人", "儿童引导师", "放映员", "剧本杀编剧", "舞美设计师"
          ],
          "广告": [
            "策划经理", "广告文案", "广告客户执行", "广告创意策划", "创意总监", "广告设计", "美术指导", "广告制作", "广告审核", "广告/会展项目经理"
          ],
          "采编/写作/出版": [
            "文案编辑", "作者/撰稿人", "编辑", "印刷排版", "校对录入", "记者/采编", "网站编辑", "主编/副主编", "出版发行", "剧本杀编剧"
          ]
        },
        "市场/公关/广告": {
          "市场营销": [
            "市场营销策划", "海外市场", "活动策划执行", "会务/会展执行", "会务/会展策划", "市场总监", "CMO"
          ],
          "推广/投放": [
            "市场推广/地推", "网络推广", "游戏推广", "媒介投放", "媒介商务BD", "媒介专员", "媒介经理/总监", "信息流优化师", "SEO", "SEM"
          ],
          "政府事务": [
            "政府关系", "项目申报专员", "政策研究", "社工"
          ],
          "公关": [
            "品牌公关", "公关总监"
          ],
          "广告": [
            "策划经理", "广告文案", "广告客户执行", "广告创意策划", "创意总监", "广告设计", "美术指导", "广告制作", "广告审核", "广告/会展项目经理"
          ],
          "调研分析": [
            "市场调研", "选址开发", "商业数据分析"
          ],
          "广告/会展销售": [
            "广告销售", "会展活动销售", "会议活动销售"
          ]
        },
        "供应链": {
          "供应链": [
            "供应链专员", "供应链经理", "供应链总监", "生产计划/物料管理(PMC)"
          ],
          "采购/贸易": [
            "采购专员/助理", "采购经理/主管", "采购工程师", "买手", "供应商质量工程师", "商品专员/助理", "采购总监", "招标专员", "投标专员", "商品经理/主管"
          ]
        },
        "汽车": {
          "电池工程师/电机工程师": [
            "电池工程师", "电机工程师"
          ],
          "汽车研发/制造": [
            "汽车项目管理", "汽车质量工程师", "汽车工艺工程师", "汽车设计", "线束设计", "车身工程师", "汽车造型设计", "汽车零部件设计", "汽车电子工程师", "自动驾驶系统工程师", "动力系统工程师", "内外饰设计工程师", "底盘工程师", "总布置工程师"
          ],
          "汽车服务": [
            "汽车维修", "汽车美容", "洗车工", "汽车改装", "汽车服务顾问", "4S店店长/维修站长", "二手车评估师", "汽车查勘定损", "加油员"
          ],
          "汽车销售": [
            "汽车销售", "汽车配件销售"
          ]
        },
        "医疗健康": {
          "护士/护理": [
            "护士", "导医", "护士长", "护工"
          ],
          "医生/医技": [
            "外科医生", "内科医生", "皮肤科医生", "妇产科医生", "儿科医生", "眼科医生", "精神心理科医生", "整形医生", "全科医生", "耳鼻喉科医生", "医学检验", "放射科医生", "超声科医生", "麻醉科医生", "病理科医生", "医生助理", "中医", "口腔科医生", "幼儿园保健医", "药剂师", "验光师", "医务管理", "其他医生职位"
          ],
          "理疗保健": [
            "理疗师", "营养师/健康管理师", "针灸推拿", "康复治疗师", "产后康复师", "心理咨询师", "按摩师", "足疗师", "采耳师"
          ],
          "药店": [
            "药店店员", "执业药师/驻店药师", "药店店长"
          ],
          "生物医药": [
            "生物学研究人员", "医药研发", "生物信息工程师", "药品生产", "药品注册", "医药项目经理", "细胞培养员", "药理毒理研究员", "药物合成", "制剂研发", "药物分析", "医疗产品技术支持"
          ],
          "临床试验": [
            "临床协调员", "临床监查员", "临床项目经理", "临床数据分析", "临床医学经理/专员", "临床医学总监"
          ],
          "医疗器械": [
            "医疗器械生产/质量管理", "医疗器械研发", "医疗器械注册", "试剂研发"
          ],
          "医疗销售": [
            "医药代表", "医疗器械销售", "医美咨询", "健康顾问", "口腔咨询师"
          ],
          "其他医疗健康职位": [
            "医学编辑", "其他医疗健康职位"
          ]
        },
        "金融": {
          "证券/基金/期货": [
            "证券交易员", "卖方分析师", "买方分析师", "投资银行业务", "基金经理", "量化研究员"
          ],
          "中后台": [
            "风控", "合规稽查", "资信评估", "清算", "资产评估", "金融产品经理", "催收员"
          ],
          "投融资": [
            "投资经理", "投资助理", "行业研究", "融资", "投后管理", "并购", "投资总监/VP", "投资者关系/证券事务代表", "其他投融资职位"
          ],
          "保险": [
            "保险理赔", "保险精算师"
          ],
          "金融销售": [
            "理财顾问", "保险顾问", "信用卡销售", "证券经纪人"
          ]
        },
        "项目管理": {
          "项目管理": [
            "项目经理/主管", "项目专员/助理", "建筑施工项目经理", "装修项目经理", "软件项目经理", "房地产项目管理", "通信项目经理", "硬件项目经理", "咨询项目管理", "物流/仓储项目经理", "广告/会展项目经理", "汽车项目管理", "生产制造项目经理", "化工项目经理", "临床项目经理", "医药项目经理"
          ]
        },
        "咨询/翻译/法律": {
          "咨询/调研": [
            "知识产权/专利/商标代理人", "项目申报专员", "咨询项目管理", "企业管理咨询", "战略咨询", "财务顾问", "IT咨询顾问", "咨询经理", "人力资源咨询顾问", "猎头顾问", "咨询总监", "市场调研", "数据分析师", "心理咨询师", "婚恋咨询师", "工程咨询", "其他咨询顾问"
          ],
          "翻译": [
            "英语翻译", "日语翻译", "韩语/朝鲜语翻译", "俄语翻译", "西班牙语翻译", "德语翻译", "法语翻译", "其他语种翻译"
          ],
          "法律服务": [
            "律师助理", "知识产权律师", "律师"
          ]
        },
        "能源/环保/农业": {
          "能源/地质": [
            "光伏系统工程师", "风电/光伏运维工程师", "水利工程师", "地质工程师", "电力工程师"
          ],
          "环保": [
            "EHS工程师", "环境采样/检测员", "环评工程师", "环保工程师", "碳排放管理师"
          ],
          "农/林/牧/渔": [
            "农业/林业技术员", "饲养员", "养殖技术员", "畜牧兽医"
          ]
        },
        "高级管理": {
          "高级管理职位": [
            "总裁/总经理/CEO", "副总裁/副总经理/VP", "总助/CEO助理/董事长助理", "区域负责人(辖多个分公司)", "分公司/代表处负责人", "董事会秘书", "联合创始人", "高级管理职位"
          ]
        }
      },
      selectedJobs: [],
      showRequirements: 0, // 0-选择岗位 1-展示岗位要求 2-加载中
      jobContent: [],
      jobRequirements: [],
      avatar: require("./assets/img/FigmaDDSSlicePNGbcf9180e8816925152134cd8a374a7de.png"),
      dialogVisible: false,
      dropdownVisible: false,
      languageDropdownVisible: false,
      MetaHumanShow: false,
      MetaHumanClicked: false,
      MetaHumanClickable: true,
      duration: "25min",
      language: "中文",
      waitingForPrompt: false,
      account: "",
      nickname: "",
      showWechatModal: false,
      wechatQRCodeUrl: require("./assets/img/qrcode.png"),
      showResumeLibraryModal: false,
      resumeLibraryList: [],
      wsConnected: false,
      qrCodeLoading: false,
      showSearchInput: true,
      showSearch: false, // 控制搜索结果显示
      JobInformation: [], // 搜索结果数据
    };
  },
  async mounted() {
    this.$store.dispatch("interviewState/setInterviewDuration", 25);
    this.$store.dispatch("interviewState/setInterviewLanguage", 1);
    this.checkLoginStatus();
    // this.loginInfo();
    // this.getInfo();


    // 设置WebSocket消息监听器
    this.setupWebSocketListeners();
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener("click", this.handleDocumentClick);
    // 关闭WebSocket连接
    closeWebSocketConnection();
  },
  methods: {
    ...dropdownMethods,
    // 简历库相关方法
    async openResumeLibraryModal() {
      this.showResumeLibraryModal = true;
      await this.loadResumeLibrary();
    },
    closeResumeLibraryModal() {
      this.showResumeLibraryModal = false;
    },
    async loadResumeLibrary() {
      try {
        const response = await getResumeList();
        if (response && response.data && response.data.code === 1) {
          const list = response.data.data || [];
          this.resumeLibraryList = list.map(item => {
            const name = item.resume_name || item.name || '';
            const rawSize = item.resume_size !== undefined ? item.resume_size : item.size;
            const sizeStr = typeof rawSize === 'number' ? `${rawSize} MB` : (rawSize || '');
            const rawTime = item.upload_time || item.create_time;
            const uploadTime = rawTime ? this.formatTime(rawTime) : '';
            const url = item.resume_url || item.url || '';
            return { name, size: sizeStr, uploadTime, url };
          });
        }
      } catch (error) {
        console.error('获取简历库失败:', error);
        this.$message.error('获取简历库失败');
      }
    },
    selectResume(resume) {
      // 保存选中的简历到本地存储
      localStorage.setItem("cv_url", resume.url);
      localStorage.setItem("cv_name", resume.name);
      
      // 更新store状态
      this.$store.commit("interviewState/SET_CV", {
        url: resume.url,
        name: resume.name,
        raw: null,
      });
      
      this.$message.success('简历选择成功');
      this.closeResumeLibraryModal();
    },
    goToResumeManagement() {
      this.closeResumeLibraryModal();
      this.$router.push('/store/personal/resume');
    },
    formatTime(val) {
      try {
        const date = typeof val === 'number' ? new Date(val) : new Date(String(val).replace(/-/g, '/'));
        if (isNaN(date.getTime())) return String(val);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
      } catch (e) {
        return String(val);
      }
    },
    returnSearch() {
      this.showSearch = false;
      this.showSearchInput = true;
    },
    searchChange() {
      if (!this.searchQuery || !this.searchQuery.trim()) {
        this.JobInformation = []
        return
      }

      const query = this.searchQuery.trim().toLowerCase()
      const results = []

      // 遍历所有类别和岗位
      for (const [categoryName, categoryJobs] of Object.entries(this.jobs)) {
        for (const [domainName, jobList] of Object.entries(categoryJobs)) {
          for (const jobName of jobList) {
            // 搜索岗位名称或所属类别
            if (
              jobName.toLowerCase().includes(query) ||
              categoryName.toLowerCase().includes(query) ||
              domainName.toLowerCase().includes(query)
            ) {
              // 避免重复
              if (!results.find(item => item.name === jobName)) {
                results.push({
                  name: jobName,
                  categories: categoryName,
                  domain: domainName
                })
              }
            }
          }
        }
      }

      this.JobInformation = results
      // 如果没有搜索结果，显示提示
      if (results.length === 0) {
        this.$message.info('未找到匹配的岗位')
      }
    },
    handleSelectJob(item) {
      this.selectedJobs.splice(0); // 清空
      this.selectedJobs[0] = item.name;
    },
    searchVal() {
      this.showSearch = true;
    },
    handleMenuSelect(item) {
      console.log("点击了菜单项:", item);
    },
    // 切换展开/收缩状态
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 处理头像点击事件
    handleAvatarClick(index) {
      // 这里可以添加头像点击后的逻辑
      alert(`点击了头像 ${index + 1}`);
    },
    // 生成TXT文件并上传
    async generateAndUploadTxt() {
      try {
        // 1. 准备TXT内容
        let txtContent = "";
        const positionName = this.selectedJobs[0] || this.manualJob;
        txtContent += `岗位名称：${positionName}\n\n`;

        // 添加工作内容
        txtContent += "工作内容：\n";
        this.jobContent.forEach((item, index) => {
          txtContent += `${index + 1}. ${item}\n`;
        });

        // 添加岗位要求
        txtContent += "\n岗位要求：\n";
        this.jobRequirements.forEach((item, index) => {
          txtContent += `${index + 1}. ${item}\n`;
        });
        const blob = new Blob([txtContent], { type: "text/plain" });
        const fileName = `AIJobInformation.txt`;
        const file = new File([blob], fileName, { type: "text/plain" });

        const formData = new FormData();
        formData.append("file", file);

        const response = await lxUploadFile(formData);

        if (response.data && response.data.data && response.data.data.url) {
          // 保存文件URL到本地存储
          localStorage.setItem("jd_url", response.data.data.url);
          localStorage.setItem("jd_name", response.data.data.name || fileName);

          // 更新store状态
          this.$store.commit("interviewState/SET_JD", {
            url: response.data.data.url,
            name: response.data.data.name || fileName,
            raw: file,
          });
        } else {
          this.$message.error("岗位要求生成失败");
        }
      } catch (error) {
        console.error("岗位要求生成失败:", error);
        this.$message.error("岗位要求生成失败，请稍后再试");
      }
    },
    openModal() {
      this.showModal = true;
    },
    handleClose() {
      this.showModal = false;

      this.selectedJobs = [];
      this.showRequirements = 0;
      this.currentCategory = "技术";
    },
    handleCategoryClick(category) {
      this.currentCategory = category;
    },
    handleJobClick(job) {
      this.selectedJobs.splice(0); // 清空
      this.selectedJobs.push(job); // 只放当前这一项
    },
    handleJobClose(job) {
      this.selectedJobs = [];
    },
    async generateRequirements() {
      if (this.selectedJobs.length > 0) {
        this.showSearch = false;
        this.loading = true;
        this.showRequirements = 1;
        this.showSearchInput = false;
        try {
          const { data } = await generateJDByPosition({
            position: this.selectedJobs.join(","),
          });
          const desc = data.data.position_description || [];

          // 找到两个标题的索引
          const workStart = desc.findIndex((d) => d.includes("## 工作内容"));
          const reqStart = desc.findIndex((d) => d.includes("## 岗位要求"));

          if (workStart !== -1 && reqStart !== -1) {
            this.jobContent = desc
              .slice(workStart + 1, reqStart)
              .map((s) => s.trim())
              .filter((s) => s && !s.startsWith("##"));

            this.jobRequirements = desc
              .slice(reqStart + 1)
              .map((s) => s.trim())
              .filter((s) => s && !s.startsWith("##"));
          } else {
            this.jobContent = [];
            this.jobRequirements = [];
          }
          const jobInformation = {
            position: this.selectedJobs.join(","),
            jobContent: this.jobContent,
            jobRequirements: this.jobRequirements,
          };
          localStorage.setItem(
            "jobInformation",
            JSON.stringify(jobInformation)
          );
          // 生成成功后自动上传TXT
          this.generateAndUploadTxt();
        } finally {
          this.loading = false;
        }
      } else if (this.manualJob != "") {
        this.loading = true;
        this.showManualInput = false;
        this.showRequirements = 1;
        try {
          const { data } = await generateJDByPosition({
            position: this.manualJob,
          });
          const desc = data.data.position_description || [];

          // 找到两个标题的索引
          const workStart = desc.findIndex((d) => d.includes("## 工作内容"));
          const reqStart = desc.findIndex((d) => d.includes("## 岗位要求"));

          if (workStart !== -1 && reqStart !== -1) {
            this.jobContent = desc
              .slice(workStart + 1, reqStart)
              .map((s) => s.trim())
              .filter((s) => s && !s.startsWith("##"));

            this.jobRequirements = desc
              .slice(reqStart + 1)
              .map((s) => s.trim())
              .filter((s) => s && !s.startsWith("##"));
          } else {
            this.jobContent = [];
            this.jobRequirements = [];
          }
          const jobInformation = {
            position: this.manualJob,
            jobContent: this.jobContent,
            jobRequirements: this.jobRequirements,
          };
          localStorage.setItem(
            "jobInformation",
            JSON.stringify(jobInformation)
          );
        } finally {
          this.loading = false;
        }
      } else {
        this.$message.warning("请先选择一个岗位");
      }
    },
    handleManual() {
      this.showManualInput = true;
      this.manualJob = ""; // 重置
      this.$nextTick(() => {
        if (this.$refs.manualInputRef) {
          this.$refs.manualInputRef.focus();
        }
      });
    },
    handleManualConfirm() {
      if (!this.manualJob.trim()) {
        this.$message.warning("请输入岗位名称");
        return;
      }
      this.selectedJobs = [this.manualJob.trim()];
      this.showManualInput = false;
      this.generateRequirements();
    },
    handleManualCancel() {
      this.showManualInput = false;
      this.manualJob = "";
    },
    handleBack() {
      this.showRequirements = false;
      this.showManualInput = false;
      this.showSearchInput = true;
    },
    handleConfirm() {
      this.showModal = false;
      // 确认后自动上传生成的TXT
      this.generateAndUploadTxt();
    },
    // 处理点击文档的事件
    handleDocumentClick(e) {
      const dropdown = this.$el.querySelector(".custom-dropdown-container");
      if (dropdown && !dropdown.contains(e.target)) {
        this.closeDropdown();
      }
    },
/*     async getInfo() {
      let res = await getUserInfo();
      if (res.data.code == 1) {
        this.avatar = res.data.data.avatar;
      } else if (res.data.code == -1) {
        this.$message({
          message: "登录状态失效将在2S后重新登录",
          type: "error",
        });
        await new Promise((resolve) => setTimeout(resolve, 3000));
        await this.$store.dispatch("user/logout");
      }
    }, */
    // 检查本地存储中的文件
    checkLocalFiles() {
      // 检查 localStorage 中的 CV
      const cvUrl = localStorage.getItem("cv_url");
      const cvName = localStorage.getItem("cv_name");
      if (cvUrl && cvName) {
        // 不需要设置uploadFiles，因为组件状态由computed属性控制
        // this.$refs.CvUpload.uploadFiles = [{ name: cvName, raw: null }];
        // this.CvUploaded = true;
      }

      // 检查 localStorage 中的 JD
      const jdUrl = localStorage.getItem("jd_url");
      const jdName = localStorage.getItem("jd_name");
      if (jdUrl && jdName) {
        // 不需要设置uploadFiles，因为组件状态由computed属性控制
        // this.$refs.JdUpload.uploadFiles = [{ name: jdName, raw: null }];
        // this.JdUploaded = true;
      }
    },
    // 检查登录状态
    checkLoginStatus() {
      const authService = this.$authService || require('@/services/AuthService').default
      authService.checkLoginStatus()
    },
/*     loginInfo() {
      if (!getToken()) localStorage.removeItem("userInfo");
      if (localStorage.getItem("userInfo")) {
        const info = JSON.parse(localStorage.getItem("userInfo"));
        this.account = info.account;
      }
    }, */
    async UploadCvFunc(file) {
      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("file", file.raw);

        // 调用lxUploadFile上传到对象存储
        const response = await lxUploadFile(formData);

        if (response.data && response.data.data && response.data.data.url) {
          // 保存文件URL到本地存储
          localStorage.setItem("cv_url", response.data.data.url);
          localStorage.setItem("cv_name", response.data.data.name || file.name);

          // 更新store状态
          this.$store.commit("interviewState/SET_CV", {
            url: response.data.data.url,
            name: response.data.data.name || file.name,
            raw: file.raw,
          });
        } else {
          this.$message.error("简历上传失败");
        }
      } catch (error) {
        console.error("简历上传失败:", error);
        this.$message.error("简历上传失败，请稍后再试");
      }
    },
    RemoveCvFunc() {
      localStorage.removeItem("cv_url");
      localStorage.removeItem("cv_name");
      // 更新store状态，这会自动更新computed属性
      this.$store.commit("interviewState/SET_CV", null);
      // 清理el-upload组件的内部状态
      if (this.$refs.CvUpload) {
        this.$refs.CvUpload.clearFiles();
      }
    },
    async UploadJdFunc(file) {
      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("file", file.raw);

        // 调用lxUploadFile上传到对象存储
        const response = await lxUploadFile(formData);

        if (response.data && response.data.data && response.data.data.url) {
          // 保存文件URL到本地存储
          localStorage.setItem("jd_url", response.data.data.url);
          localStorage.setItem("jd_name", response.data.data.name || file.name);

          // 更新store状态
          this.$store.commit("interviewState/SET_JD", {
            url: response.data.data.url,
            name: response.data.data.name || file.name,
            raw: file.raw,
          });
        } else {
          this.$message.error("岗位要求上传失败");
        }
      } catch (error) {
        console.error("岗位要求上传失败:", error);
        this.$message.error("岗位要求上传失败，请稍后再试");
      }
    },
    RemoveJdFunc() {
      localStorage.removeItem("jd_url");
      localStorage.removeItem("jd_name");
      // 更新store状态，这会自动更新computed属性
      this.$store.commit("interviewState/SET_JD", null);
      // 清理el-upload组件的内部状态
      if (this.$refs.JdUpload) {
        this.$refs.JdUpload.clearFiles();
      }
    },
    ClickMetaHuman() {
      if (!this.MetaHumanClickable) return;
      this.MetaHumanShow = !this.MetaHumanShow;
      this.MetaHumanClicked = true;
      this.MetaHumanClickable = false;
    },
    gotomianshilishi() {
      this.$router.push("/interview_mianshilishi");
    },
    getRequirements() {
      this.showSearch = false;
      this.generatedLoading = true;
      setTimeout(() => {
        this.generatedLoading = false;
        this.generateCompleted = true;
      }, 2000);
    },
    async handleClickReadyGo() {
      try {
        const currentJob = this.$store.state.interviewState.currentInterviewJob
        const jobId = currentJob?.id || currentJob?.job_id || null
        
        const res = await checkInterview(jobId)
        const canInterview  = res && res.data && res.data.data

        if (!canInterview) {
          this.$message.warning('免费次数已用完，请先订阅')
          this.$router.push({ name: 'personalSubscribe' }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('导航失败:', err)
            }
          })
          return
        }

        const jdUrl = this.$store.state.interviewState.jd?.url
        const cvUrl = this.$store.state.interviewState.cv?.url
        if (jdUrl && cvUrl) {
          this.$store.dispatch('interviewState/generatePromptInBackground', { jdUrl, cvUrl })
        }
        
        // 调用获取推荐id的接口
        if (jdUrl && cvUrl) {
          try {
            const { data } = await getRecommendId({
              jd_url: jdUrl,
              resume_url: cvUrl,
              total_num: 10,
            });
            if (data.code === 1) {
              this.$store.dispatch("interviewState/setRecommendId", data.msg);
            } else {
              console.error("获取推荐任务ID失败:", data.msg);
            }
          } catch (error) {
            console.error("获取推荐ID失败:", error);
          }
        }

        // 通过检查后，继续后续流程
        this.$router.push('/store/select_metahuman').catch(err => {
          // 忽略导航重复错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('导航失败:', err)
          }
        })
      } catch (error) {
        console.error('检查面试次数失败:', error)
        this.$message.error('检查面试次数失败，请稍后重试')
      }
    },
    openWechatUploadModal() {
      this.showWechatModal = true;
      this.generateWechatQRCode();
    },
    closeWechatModal() {
      this.showWechatModal = false;
      // 关闭WebSocket连接
      if (this.wsConnected) {
        closeWebSocketConnection();
        this.wsConnected = false;
      }
    },
    async generateWechatQRCode() {
      try {
        this.qrCodeLoading = true;

        // 获取当前用户ID
        const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        const userId = userInfo.id || userInfo.userId;

        if (!userId) {
          this.$message.error("请先登录");
          return;
        }

        // 调用API生成二维码
        const response = await generate_qrcode();

        if (response.data && response.data.code === 1) {
          // 拼接PNG的data URL前缀
          this.wechatQRCodeUrl = `data:image/png;base64,${response.data.data}`;

          // 建立WebSocket连接
          await this.connectWebSocket(userId);

          this.$message.success("二维码生成成功，请使用微信扫码上传");
        } else {
          this.$message.error(response.data?.msg || "二维码生成失败");
        }
      } catch (error) {
        console.error("生成二维码失败:", error);
        this.$message.error("二维码生成失败，请稍后再试");
      } finally {
        this.qrCodeLoading = false;
      }
    },
    async connectWebSocket(userId) {
      try {
        await createWebSocketConnection(userId);
        this.wsConnected = true;
        console.log("WebSocket连接成功");
      } catch (error) {
        console.error("WebSocket连接失败:", error);
        this.$message.warning("实时连接失败，但二维码仍可使用");
      }
    },
    setupWebSocketListeners() {
      // 监听文件上传完成消息
      onWebSocketMessage("file_upload_complete", (data) => {
        console.log("收到文件上传完成消息:", data);
        this.handleFileUploadComplete(data);
      });

      // 监听连接状态变化
      onWebSocketMessage("connection_status", (data) => {
        console.log("WebSocket连接状态:", data);
        this.wsConnected = data.connected;
      });
    },
    handleFileUploadComplete(data) {
      // 兼容不同的字段名格式
      const resumeUrl = data.resume_url || data.resumeUrl;
      const jdUrl = data.jd_url || data.jdUrl;

      console.log("处理文件上传完成:", { resumeUrl, jdUrl });

      // 处理简历文件
      if (resumeUrl) {
        this.handleResumeUpload(resumeUrl);
      }

      // 处理岗位要求文件
      if (jdUrl) {
        this.handleJDUpload(jdUrl);
      }

      // 关闭弹窗
      this.closeWechatModal();

      this.$message.success("文件上传成功！");
    },
    handleResumeUpload(resumeUrl) {
      // 更新store状态
      this.$store.commit("interviewState/SET_CV", {
        url: resumeUrl,
        name: "微信上传简历.pdf",
        raw: null,
      });

      // 保存到本地存储
      localStorage.setItem("cv_url", resumeUrl);
      localStorage.setItem("cv_name", "微信上传简历.pdf");
      
    },
    handleJDUpload(jdUrl) {
      // 更新store状态
      this.$store.commit("interviewState/SET_JD", {
        url: jdUrl,
        name: "微信上传岗位要求.pdf",
        raw: null,
      });

      // 保存到本地存储
      localStorage.setItem("jd_url", jdUrl);
      localStorage.setItem("jd_name", "微信上传岗位要求.pdf");
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .el-upload {
  width: 100%;
  height: 100%;
}

::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
  background: none;
  border: none;
}

.page {
  background-color: rgba(255, 255, 255, 1);
  background: url(./assets/img/dash_1x.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text_1 {
  /* 保留原始文本渐变色 */
  background-image: linear-gradient(
    90deg,
    rgba(126, 180, 235, 1) 0,
    rgba(177, 110, 249, 1) 100%
  );
  width: 525px;
  height: 60px;
  overflow-wrap: break-word;
  font-size: 45px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text_2 {
  width: 141px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 18px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.text_3 {
  width: 162px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 18px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.group_5 {
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  background-image: linear-gradient(
    315deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.4) 100%
  );
  border-radius: 18px;
  height: 280px;
  border: 1px solid #b16ef9;
  width: 246px;
}

.section_2 {
  border-radius: 15px;
  width: 220px;
  height: 251px;
  border: 3px dashed rgba(126, 180, 235, 1);
  margin: 14px 0 0 14px;
}

.image-text_1 {
  width: 156px;
  height: 111px;
  margin: 45px 0 0 32px;
}

.image_2 {
  width: 100px;
  height: 71px;
  margin: auto;
}

.text-group_1 {
  width: 156px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 12px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 15px;
  margin-top: 10px;
}

.box_3 {
  width: 77px;
  height: 20px;
  margin: 56px 0 29px 80px;
}

.text_6 {
  width: 61px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 15px;
  font-family: Afacad-SemiBold;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 15px;
}

.group_6 {
  background-image: linear-gradient(
    180deg,
    rgba(177, 110, 249, 1) 0,
    rgba(126, 180, 235, 1) 100%
  );
  width: 17px;
  height: 16px;
  margin-left: 4px;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.group_7 {
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  background-image: linear-gradient(
    315deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.4) 100%
  );
  border-radius: 18px;
  width: 246px;
  height: 77px;
  border: 1px solid #b16ef9;
  margin-top: 40px;
}

.text_7 {
  width: 125px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 14px;
  font-family: Afacad-SemiBold;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 15px;
  margin: 14px 0 0 20px;
}

.group_10 {
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  background-image: linear-gradient(
    315deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.4) 100%
  );
  border-radius: 18px;
  height: 280px;
  border: 1px solid #b16ef9;
  width: 246px;
}

.box_4 {
  border-radius: 15px;
  width: 220px;
  height: 251px;
  border: 3px dashed rgba(126, 180, 235, 1);
  margin: 14px 0 0 14px;
}

.image-text_2 {
  width: 156px;
  height: 111px;
  margin: 45px 0 0 32px;
}

.image_3 {
  width: 100px;
  height: 71px;
  margin-left: 29px;
}

.text-group_2 {
  width: 156px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 12px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: center;
  line-height: 15px;
  margin-top: 10px;
}

.box_5 {
  display: flex;
  flex-direction: column;
  width: 95px;
  height: 20px;
  margin: 56px 0 29px 71px;
}

.text_9 {
  width: 78px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 15px;
  font-family: Afacad-SemiBold;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 15px;
}

.text_11 {
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 11px;
  font-family: Afacad-SemiBold;
}

.section_3 {
  background-image: linear-gradient(
    180deg,
    rgba(177, 110, 249, 1) 0,
    rgba(126, 180, 235, 1) 100%
  );
  width: 17px;
  height: 16px;
  margin-left: 4px;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

.text-wrapper_5 {
  height: 77px;
  background: linear-gradient(
      90deg,
      rgba(101, 101, 135, 0.4) 0%,
      rgba(101, 101, 135, 0.4) 100%
    ),
    linear-gradient(
      321deg,
      rgba(255, 255, 255, 0) 2.06%,
      rgba(255, 255, 255, 0.4) 99.08%
    );
  border-radius: 18px;
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.15);
  background-size: 100% 100%;
  margin-top: 23px;
  width: 246px;
  align-items: center;
  justify-content: center;
}

.text_10 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.25);
  font-size: 18px;
  font-family: Afacad-SemiBold;
  font-weight: NaN;
  text-align: center;
}

.color-text {
  /* 保留原始文本渐变色 */
  background-image: linear-gradient(
    0deg,
    rgba(126, 180, 235, 1) 0,
    rgba(177, 110, 249, 1) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.color-background {
  background-image: linear-gradient(
    180deg,
    rgba(126, 180, 235, 0.15) 0,
    rgba(177, 110, 249, 0.15) 100%
  );
}

.ready-go {
  background-image: linear-gradient(
    90deg,
    rgba(126, 180, 235, 1) 0,
    rgba(177, 110, 249, 1) 100%
  );
}

.arrow_rotate_up {
  transform: rotate(180deg);
}

.spinner {
  border: 5px solid rgba(126, 180, 235, 1);
  border-radius: 50%;
  border-top: 5px solid rgba(177, 110, 249, 1);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.custom-dropdown-container {
  position: relative;
  display: inline-block;
  margin-top: 0.6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.custom-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1vw;
  box-shadow: 0 0.5vh 10px 0 rgba(0, 0, 0, 0.1);
  padding: 0.3vw;
  background: linear-gradient(
    180deg,
    rgba(126, 180, 235, 0.15) 0%,
    rgba(177, 110, 249, 0.15) 100%
  );
  cursor: pointer;
  border: none;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.custom-dropdown {
  position: absolute;
  top: calc(100% + -36px);
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(177, 110, 249, 0.3);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  padding: 5px 0;
}

.custom-dropdown-item {
  /* 保留原始文本渐变色 */
  padding: 8px 12px;
  cursor: pointer;
  text-align: center;
  background-image: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  position: relative;
  z-index: 2;
  font-weight: bold;
  font-size: 12px;
}

.custom-dropdown-item:hover {
  background-color: rgba(177, 110, 249, 0.15);
}

.el-icon-arrow-down {
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.custom-arrow-icon {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.arrow_rotate_up {
  transform: rotate(180deg);
}

.group_3 {
  border: 1px solid #7eb4eb;
}

.group_5 .group_7 .group_10 {
  border: 1px solid #b16ef9;
}

/* 触发按钮样式 */
.open-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #7e6ef8;
  color: white;
  border: none;
}

.open-btn:hover {
  background-color: #6a5ee0;
}

/* 弹窗样式 */
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: all 0.3s;
}
.sidebar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: -1;
}
.modal-content {
  background: linear-gradient(
    321deg,
    rgba(255, 255, 255, 0) 2.06%,
    rgba(255, 255, 255, 0.2) 99.08%
  );
  backdrop-filter: blur(23.649999618530273px);
  border-radius: 34px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 80%;
  max-width: 960px;
  position: relative;
  z-index: 1;
  animation: modalFadeIn 0.3s;
}

@keyframes modalFadeIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
}

.title {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
}

.content {
  display: flex;
  height: calc(100vh - 180px);
  position: relative;
}

.sidebar {
  width: 200px;
  // background-color: #DFE1EB;
  padding-bottom: 20px;
  position: relative;
  overflow-y: auto;
  max-height: 100%;
}

.sidebar-item {
  padding: 12px 20px;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  font-family: Afacad;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 10px;
}

.sidebar-item:hover {
  color: #656587;
}

.sidebar-item.active {
  color: #656587;
  font-weight: 700;
  background-color: #fff;
  font-size: 18px;
}

.main-content {
  flex: 1;
  padding: 40px 40px 40px 40px;
  opacity: 1;
  position: relative;
  z-index: 0;

  height: 100%;
  position: relative;
}

.category {
  max-height: calc(100% - 80px);
  overflow-y: auto;
}

.category-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.job-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.job-item {
  background: #f0f0f3;
  padding: 12px 10px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  color: #656587;
  font-family: Afacad;
  font-style: normal;
  font-weight: 500;
  box-sizing: border-box;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.job-item.selected {
  border-color: transparent; /* 由伪元素绘制渐变边框 */
  background: linear-gradient(
    90deg,
    rgba(119, 186, 255, 1) 0%,
    rgba(156, 65, 255, 1) 100%
  );
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}

/* 使用伪元素绘制可与圆角适配的渐变边框 */
.job-item.selected::before {
  content: "";
  position: absolute;
  inset: -2px; /* 扩展到边框外 */
  border-radius: 4px; /* 与job-item保持一致 */
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  padding: 2px; /* 边框宽度 */
  z-index: -1; /* 放在元素后面 */
  pointer-events: none;
}

.job-item.selected .close {
  display: inline-block;
}

.close {
  display: none;
  margin-left: 6px;
  color: #a8b3d9;
  font-weight: normal;
}

.buttons {
  position: absolute;
  left: 40px;
  right: 40px;
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  bottom: 40px;
  align-items: center;
}
.buttons-left,
.buttons-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.buttons-right {
  margin-left: auto;
}
.button-group-center {
  justify-content: center;
}

.button-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.btn-disabled {
  background: #bebebe !important;
  color: white !important;
  border: none !important;
  cursor: not-allowed;
  border: 1px solid #bebebe;
}
.btn-primary {
  background-color: #7e6ef8;
  color: white;
  border: none;
}

.btn-primarys {
  border-radius: 8px;
  background: linear-gradient(to right, #66b3ff, #9f4dff);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #f0fbff;
  text-align: center;
  font-family: Afacad;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.btn-manual {
  border-radius: 8px;
  background: transparent;
  border: 2px solid;
  border-image: linear-gradient(90deg, #66b3ff, #9f4dff) 1;
  color: transparent;
  background: linear-gradient(90deg, #66b3ff, #9f4dff);
  background-clip: text;
  -webkit-background-clip: text;
  text-align: center;
  font-family: Afacad;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  transition: all 0.3s ease;
}
.btn-return {
  border-radius: 8px;
  background: #fff;
  color: #656587;
  text-align: center;
  font-family: Afacad;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.btn-restart {
  border-radius: 8px;
  border: 1px solid #6a5ee0;
  text-align: center;
  font-family: Afacad;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background:linear-gradient(90deg, rgba(119,186,255,1) 0%, rgba(156,65,255,1) 100%);
color:transparent;
-webkit-background-clip:text;
}
.btn-primary:hover {
  background-color: #6a5ee0;
}

.btn-outline {
  background-color: #f0f3ff;
  color: #7e6ef8;
  border: 1px solid #7e6ef8;
  border-radius: 20px;
}

.btn-outline:hover {
  background-color: #f0f3ff;
}

.generated-requirements {
  color: #656587;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  overflow-y: auto;
}

.generated-requirements h3 {
  margin-bottom: 15px;
  color: #656587;
}

.generated-requirements li {
  counter-increment: step;
  margin-bottom: 8px;
}

/* 手动输入岗位弹窗样式 */
.manual-input-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.manual-input-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 500px;
  max-width: 90vw;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.manual-input-header {
  background: linear-gradient(135deg, #9D89F9 0%, #77BAFF 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.manual-input-title {
  color: white;
  font-size: 16px;
  font-weight: 600;
  flex: 1;
}

.manual-input-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.manual-input-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.manual-input-close i {
  color: white;
  font-size: 16px;
}

.manual-input-content {
  padding: 32px 24px;
}

.manual-input-field {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 16px;
  font-family: inherit;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  margin-bottom: 32px;
}

.manual-input-field:focus {
  border-color: #9D89F9;
  box-shadow: 0 0 0 3px rgba(157, 137, 249, 0.1);
}

.manual-input-field::placeholder {
  color: #999;
}

.manual-input-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-back {
  background: transparent;
  color: #9D89F9;
  border: 2px solid #9D89F9;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  background: #9D89F9;
  color: white;
}

.btn-clear {
  background: transparent;
  color: #666;
  border: 2px solid #ddd;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-clear:hover {
  border-color: #999;
  color: #999;
}

.btn-generate {
  background: #666;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-generate:hover:not(:disabled) {
  background: #555;
}

.btn-generate:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.bg-pic {
  height:1200px;
  position:fixed;
  top:0;
  left:0;
  z-index:0;
}

/* 小屏幕适配：缩小背景图片，避免影响内容 */
@media (max-width: 1600px) {
  .bg-pic {
    height: 857px;
  }
}

/* 更小屏幕：进一步缩小 */
@media (max-width: 1200px) {
  .bg-pic {
    height: 514px;
  }
}

/* 超小屏幕：隐藏或最小化 */
@media (max-width: 768px) {
  .bg-pic {
    height: 343px;
    top: 300px;
    left: -20px;
    
  }
}

.loading {
  text-align: center;
  padding: 30px;
  color: #909399;
}

.lib {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #9890f2;
  min-width: 160px;
  padding: 0 8px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
  margin-top: -35px;
  span {
    color: #fff;
    text-align: center;
    font-family: Afacad;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.avatar-expander {
  position: fixed;
  left: 0px;
  bottom: 20px;
  height: 60px;
  width: 80px;
  background: #edeef3;
  border-radius: 8px 30px 30px 8px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  padding: 0 15px;
  transition: width 0.4s ease;
  overflow: hidden;
  z-index: 1000;
}

.image-text_1_,
.image-text_2_ {
  width: 100%;
  height: auto;
}

.avatar-expander.expanded {
  width: 280px;
}

/* 切换图片样式 */
.toggle-image {
  width: 24px;
  height: 24px;
  object-fit: contain;
  transition: transform 0.3s ease;
  min-width: 24px;
}

.UploadedColor {
  background-image: linear-gradient(
    180deg,
    rgba(126, 180, 235, 0.2) 0,
    rgba(177, 110, 249, 0.2) 100%
  );
}

.avatar-expander.expanded .toggle-image {
  transform: rotate(360deg);
}

.avatar-container {
  display: flex;
  gap: 12px;
  margin-left: 15px;
  height: 40px;
  width: 0;
  overflow: hidden;
  transition: width 0.3s ease 0.1s;
}

.avatar-expander.expanded .avatar-container {
  width: 196px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid white;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.avatar-expander.expanded .avatar {
  opacity: 1;
  transform: scale(1);
}

/* 头像逐个显示动画 */
.avatar-expander.expanded .avatar:nth-child(1) {
  transition-delay: 0.2s;
}

.avatar-expander.expanded .avatar:nth-child(2) {
  transition-delay: 0.3s;
}

.avatar-expander.expanded .avatar:nth-child(3) {
  transition-delay: 0.4s;
}

.avatar-expander.expanded .avatar:nth-child(4) {
  transition-delay: 0.5s;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar:hover {
  transform: scale(1.1);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.box_1_,
.group_6_ {
  width: 100%;
  height: 90%;
  margin: auto;
}

/* 微信扫码上传按钮样式 */
.wechat-upload-section {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.wechat-upload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(90deg, #7eb4eb 0%, #b16ef9 100%);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: none;
  min-width: 160px;
}

.wechat-upload-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.wechat-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  color: white;
}

.wechat-text {
  color: white;
  font-size: 14px;
  font-weight: 500;
  font-family: Afacad;
}

/* 内联微信扫码上传按钮样式 */
.wechat-upload-section-inline {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.wechat-upload-button-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 10px;
  background: #9890f2;
  min-width: 160px;
  padding: 0 8px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.wechat-upload-button-inline:hover {
  background: #8a7ff0;
  transform: translateY(-1px);
}

.wechat-icon-inline {
  width: 14px;
  height: 14px;
  object-fit: contain;
  color: white;
}

.wechat-text-inline {
  color: #fff;
  text-align: center;
  font-family: Afacad;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* 微信扫码上传弹窗样式 */
.wechat-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.wechat-modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: all 0.3s;
}

.wechat-modal-content {
  border: 1px solid #7eb4eb;
  background: linear-gradient(
    321deg,
    rgba(255, 255, 255, 0) 2.06%,
    rgba(255, 255, 255, 0.2) 99.08%
  );
  backdrop-filter: blur(23.649999618530273px);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 400px;
  position: relative;
  z-index: 1;
  animation: modalFadeIn 0.3s;
}

.wechat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #dfe1eb;
}

.wechat-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: center;
  flex: 1;
}
.close-btn {
  display: flex;
}
.wechat-close-btn {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.wechat-close-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.wechat-content {
  padding: 40px 24px;
  text-align: center;
}

.wechat-qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.wechat-qr-code {
  width: 200px;
  height: 200px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.wechat-hint {
  color: #656587;
  font-size: 16px;
  font-family: Afacad;
  margin: 0;
}

.qr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px 0;
}

.qr-loading p {
  color: #656587;
  font-size: 14px;
  font-family: Afacad;
  margin: 0;
}

.connection-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 15px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ccc;
  transition: background-color 0.3s ease;
}

.status-dot.connected {
  background-color: #52c41a;
}
.dot{
  background:linear-gradient(90deg, rgba(119,186,255,1) 0%, rgba(156,65,255,1) 100%);
color:transparent;
-webkit-background-clip:text;
}
.status-text {
  color: #656587;
  font-size: 12px;
  font-family: Afacad;
}

.action_row {
  display: flex;
  align-items: center;
  position: fixed;
  justify-content: space-between;
  bottom: 20px;
  margin-top: 24px;
  padding: 20px 20px 20px 20px;
  width: calc(100% - 48px);
}
.return_search {
  border: 1px solid transparent; /* 渐变边框由伪元素绘制 */
  color: #656587;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  border-radius: 4px; /* 与job-item.selected保持一致 */
}

/* 渐变边框，使用与job-item相同的圆角 */
.return_search::before {
  content: "";
  position: absolute;
  inset: -1px; /* 扩展到边框外 */
  border-radius: 4px; /* 与job-item.selected保持一致 */
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  padding: 1px; /* 边框宽度 */
  z-index: -1; /* 放在按钮后面 */
  pointer-events: none;
}





</style>

<style scoped>
/* 全局强制覆盖城市选择框宽度 */
.el-select-dropdown.city-dropdown,
.el-popper.city-dropdown,
.el-select-dropdown__wrap {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

/* 强制覆盖城市选项样式 */
.el-select-dropdown.city-dropdown .el-select-dropdown__item,
.el-select-dropdown.city-dropdown
  .el-select-group__wrap
  .el-select-dropdown__item {
  padding: 3px 4px !important;
  margin: 3px !important;
  font-size: 11px !important;
  min-height: 24px !important;
  flex: 0 0 calc(33.333% - 6px) !important;
  max-width: calc(33.333% - 6px) !important;
  width: calc(33.333% - 6px) !important;
}
.search_box {
  display: flex;
  padding: 18px;
  align-content: center;
  background: #fff;
}
.search-input {
  flex: 1;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px 0 0 8px;
  padding: 0 12px;
  font-size: 14px;
  font-family: Afacad;
  transition: border-color 0.3s, box-shadow 0.3s;
  font-size: 16px;
  backdrop-filter: blur(30px);
  box-shadow: 4px 4px 20px 0px #0000000d;
  box-shadow: 1px 1px 10px 0px #0000000d;
}
.search-input::placeholder {
  font-size: 16px;
  color: #00000066;
}
.search-icon {
  background: linear-gradient(
    320.78deg,
    rgba(255, 255, 255, 0) 2.06%,
    rgba(255, 255, 255, 0.7) 99.08%
  );
  backdrop-filter: blur(30px);
  box-shadow: 4px 4px 20px 0px #0000000d;
  color: linear-gradient(90deg, #77baff 0%, #9c41ff 100%),
    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  box-shadow: 1px 1px 10px 0px #0000000d;
  padding: 10px;
  font-size: 16px;
  border-radius: 0 8px 8px 0;
}
.row_list {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(100% - 80px);
  width: 100%;
  overflow-y: auto;
}
.row_item {
  padding: 10px 20px;
  border-radius: 12px;
  border: 2px solid transparent;
  position: relative; /* 为伪元素定位做准备 */
  z-index: 1;
  color: #656587;
}
.row_item:hover {
  background: #f4f5fe;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.1);
}
.item_title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}
.item_content {
  font-size: 16px;
}
.row_selected {
  border: 2px solid #6c5ce7;
  color: #6c5ce7;
  /* background:linear-gradient(90deg, rgba(119,186,255,1) 0%, rgba(156，65，255,1) 100%);
color:transparent;
-webkit-background-clip:text; */
}
.tips_txt {
  font-size: 24px;
  color: #656587;
  letter-spacing: 2px;
}
.loading_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* 简历库弹窗样式 */
.resume-library-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resume-library-modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}

.resume-library-modal-content {
  position: relative;
  width: 600px;
  max-height: 80vh;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(15px);
  overflow: hidden;
}

.resume-library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.resume-library-title {
  font-size: 18px;
  font-weight: bold;
  color: #1d2129;
}

.resume-library-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: #86909c;
}

.resume-library-close-btn:hover {
  background: rgba(0, 0, 0, 0.2);
  color: #1d2129;
  transform: scale(1.1);
}

.resume-library-body {
  padding: 24px;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #86909c;
  margin-bottom: 8px;
}

.empty-tip {
  font-size: 14px;
  color: #c0c4cc;
  margin-bottom: 24px;
}

.upload-resume-btn {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  transition: transform 0.2s;
}

.upload-resume-btn:hover {
  transform: translateY(-2px);
}

.resume-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.resume-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s;
}

.resume-item:hover {
  background: rgba(126, 180, 235, 0.1);
  border-color: rgba(126, 180, 235, 0.3);
  transform: translateY(-2px);
}

.resume-info {
  flex: 1;
}

.resume-name {
  font-size: 14px;
  font-weight: 500;
  color: #1d2129;
  margin-bottom: 4px;
}

.resume-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #86909c;
}

.resume-actions {
  flex-shrink: 0;
}

.select-btn {
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 12px;
  cursor: pointer;
  transition: transform 0.2s;
}

.select-btn:hover {
  transform: scale(1.05);
}
</style>
